export function ManualButton(props: React.HTMLProps<HTMLAnchorElement>) {
	const { children, ...otherProps } = props;
	return (
		<a {...otherProps} href="/manual" suppressHydrationWarning>
			{children || "Manual"}
		</a>
	);
}
